module.exports = __webpack_public_path__ + "static/media/upload.4a82a5f7.svg";